<script setup lang="ts">
import ConfirmationComponent from "@/components/ConfirmationComponent/ConfirmationComponent.vue";
import ToastComponent from "./components/ToastComponent/ToastComponent.vue";
import FullPageLoaderComponent from "./components/FullPageLoaderComponent/FullPageLoaderComponent.vue";
import { useBuildCheck } from "./composables/UseBuildCheck";
import { useSentry } from "./composables/UseSentry";
import { watchEffect } from "vue";
import { useWorkspaceSettingsStore } from "./stores/workspace-settings.store";
import { useSessionStore } from "./stores/session.store";

useBuildCheck();
useSentry();
const sessionStore = useSessionStore();
const workspaceSettingsStore = useWorkspaceSettingsStore();
watchEffect(() => {
  const session = sessionStore.selectedSession();
  if (!session) return;
  workspaceSettingsStore.initialize(session.workspaceUserGroup.id as string);
});
</script>

<template>
  <FullPageLoaderComponent />
  <!-- Components that use global providers (e.g. useconfirm) should be added here -->
  <ConfirmationComponent></ConfirmationComponent>
  <ToastComponent group="onboarding"></ToastComponent>

  <RouterView />
</template>
